import { Routes } from '@angular/router';
import { authGuardFn } from '@auth0/auth0-angular';
import { LoginComponent } from './features/login/login.component';
import { CallbackComponent } from './features/callback/callback.component';
import { ShellComponent } from './layout/shell/shell.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'callback', component: CallbackComponent },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuardFn],
    children: [
      {
        path: 'courriers',
        loadChildren: () => import('./features/courriers/courriers.routes').then(m => m.COURRIERS_ROUTES)
      },
      {
        path: 'actes',
        loadChildren: () => import('./features/actes/actes.routes').then(m => m.ACTES_ROUTES)
      },
      {
        path: 'majic',
        loadChildren: () => import('./features/majic/majic.routes').then(m => m.MAJIC_ROUTES)
      },
      {
        path: '',
        loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];
